import { combineReducers } from 'redux';
import user from './user';
import site from './site';
import dashboard from './dashboard';
import feedback from './feedback';
import contributor from './contributor';

const RootReducer = combineReducers({
    user,
    site,
    dashboard,
    feedback,
    contributor
});

export default RootReducer;
